
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhyUs from '@/components/WhyUs';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';

const AboutPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // Update SEO meta tags
    updateMetaTags({
      title: `${t.whyFutureLevel} | Future Level`,
      description: t.pageDescription || 'Lernen Sie Future Level kennen - Ihr Partner für KI-gestützte Videomarketing Lösungen in der Schweiz.',
      keywords: "Future Level Team, AI Video Expertise, Über uns, Video Marketing Geschichte, KI Videoagentur Schweiz",
      canonicalUrl: getCanonicalUrl(currentLanguage === 'de' ? 'ueber-uns' : 
                                   currentLanguage === 'en' ? 'about' : 
                                   currentLanguage === 'fr' ? 'a-propos' : 'chi-siamo', 
                                   currentLanguage),
      language: currentLanguage,
      ogType: "website"
    });
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">{t.whyFutureLevel}</h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {t.whyFutureLevelSubtitle}
            </p>
          </div>
          
          <WhyUs />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
